import React, { Suspense } from "react";
import { createRoot } from 'react-dom/client';

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { Replay } from "@sentry/replay";

import axios from "axios";

import "react-dropdown/style.css";
import { checkIsDomainAdmin } from "@tomocredit/common-fe/utils";

const App = React.lazy(() => import("./App"));
const AppAdmin = React.lazy(() => import("./AppAdmin"));

// Set axios base URL
axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

const sentryIntegrations: Sentry.BrowserOptions["integrations"] = [
  new BrowserTracing(),
];
if (process.env.REACT_APP_NODE_ENV === "development") {
  sentryIntegrations.push(
    new Sentry.Integrations.Breadcrumbs({ console: false }),
  );
}
if (process.env.REACT_APP_NODE_ENV === "production") {
  sentryIntegrations.push(
    new Replay({
      maskAllText: false,
    }),
  );
}

Sentry.init({
  dsn: "https://3fa0282fbddc461ba00e7adce9d5e5d0@o4503937355415552.ingest.sentry.io/4503978102161408",
  integrations: sentryIntegrations,
  environment: process.env.REACT_APP_NODE_ENV,
  release: process.env.REACT_APP_SENTRY_RELEASE,
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.25,
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
});

// This is the React 18 way to creating the new root: https://react.dev/blog/2022/03/08/react-18-upgrade-guide
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <Suspense fallback={null}>
    {checkIsDomainAdmin() ? <AppAdmin /> : <App />}
  </Suspense>
);
